const normalisedLobIcons = {
    PA: {
        image: 'personal-auto',
        font: 'mi-directions_car'
    },
    HO: {
        image: 'home-owners',
        font: 'mi-home'
    },
    GL: {
        image: 'general-liability',
        font: 'mi-healing'
    },
    BO: {
        image: 'business-owners',
        font: 'mi-store'
    },
    IM: {
        image: 'inland-marine',
        font: 'mi-directions_boat'
    },
    CP: {
        image: 'commercial-property',
        font: 'mi-unarchive'
    },
    CA: {
        image: 'commercial-auto',
        font: 'mi-local_shipping'
    },
    WC: {
        image: 'workers-comp',
        font: 'mi-work'
    },
    CPKG: {
        image: 'commercial-package',
        font: 'mi-unarchive'
    },
    TRVL: {
        image: 'travel',
        font: 'mi-plane'
    },
    PUL: {
        image: 'no-icon',
        font: 'fa-umbrella'
    },
    default: {
        image: 'no-icon', // Using an existing empty image as default to avoid 404s
        font: 'mi-receipt'
    }
};

const materialLobIcons = {
    PA: {
        image: 'personal-auto',
        font: 'mi-directions_car'
    },
    HO: {
        image: 'home-owners',
        font: 'mi-home'
    },
    GL: {
        image: 'general-liability',
        font: 'mi-healing'
    },
    BO: {
        image: 'business-owners',
        font: 'mi-business'
    },
    IM: {
        image: 'inland-marine',
        font: 'mi-directions_boat'
    },
    CP: {
        image: 'commercial-property',
        font: 'mi-apartment'
    },
    CPKG: {
        image: 'commercial-package',
        font: 'mi-unarchive'
    },
    CA: {
        image: 'commercial-auto',
        font: 'mi-local-shipping'
    },
    WC: {
        image: 'workers-comp',
        font: 'mi-work'
    },
    TRVL: {
        image: 'travel',
        font: 'mi-plane'
    },
    PUL: {
        image: 'no-icon',
        font: 'fa-umbrella'
    },
    default: {
        image: 'no-icon', // Using an existing empty image as default to avoid 404s
        font: 'mi-receipt'
    }
};

const lobKeys = {
    PersonalAuto: 'PA',
    PersonalAutoLine: 'PA',
    auto_per: 'PA',
    Homeowners: 'HO',
    homeowners: 'HO',
    HomeOwners: 'HO',
    HomeownersLine_HOE: 'HO',
    HomeownersLine: 'HO',
    HOPLine: 'HO',
    HOLine: 'HO',
    HOPHomeowners: 'HO',
    GeneralLiability: 'GL',
    GeneralLiabilityLine: 'GL',
    GLLine: 'GL',
    BusinessOwners: 'BO',
    BusinessOwnersLine: 'BO',
    BOPLine: 'BO',
    InlandMarine: 'IM',
    InlandMarineLine: 'IM',
    IMLine: 'IM',
    CommercialProperty: 'CP',
    CommercialPropertyLine: 'CP',
    CPLine: 'CP',
    CommercialAuto: 'CA',
    BusinessAuto: 'CA',
    BusinessAutoLine: 'CA',
    WorkersComp: 'WC',
    WorkersCompLine: 'WC',
    WC7WorkersComp: 'WC',
    CommercialPackage: 'CPKG',
    CommercialPackageLine: 'CPKG',
    travel_perLine: 'TRVL',
    PersonalUmbrellaLine: 'PUL'
};

const getNormalisedObject = (lobCode) => {
    const normalisedKey = lobKeys[lobCode] || 'default';
    return normalisedLobIcons[normalisedKey];
};

const getMaterialObject = (lobCode) => {
    const normalisedKey = lobKeys[lobCode] || 'default';
    return materialLobIcons[normalisedKey];
};

const getImageIcon = (lobCode) => {
    return getNormalisedObject(lobCode).image;
};

const getFontIcon = (lobCode) => {
    return getNormalisedObject(lobCode).font;
};

const getMaterialIcon = (lobCode) => {
    return getMaterialObject(lobCode).font;
};

export default {
    getImageIcon: getImageIcon,
    getFontIcon: getFontIcon,
    getMaterialIcon: getMaterialIcon
};
